export default __webpack_public_path__ + "static/media/tracker.9644a445.svg";